import styled from "styled-components/macro";
import type { IIsOutOfView } from "../../util/util";

export const DropDownWrapper = styled.div<{
  size?: "small" | "default";
}>`
  display: inline-block;
  position: relative;
  button {
    cursor: pointer;
  }

  ${({ size }) =>
    size === "small"
      ? `
        margin-right: 0;
       
      `
      : `
        margin: 3px 0px 2px 0;
      `}
`;

export interface IDropDownModalWrapperProps {
  isOutOfViewport?: IIsOutOfView;
}
export const DropDownModalWrapper = styled.div<IDropDownModalWrapperProps>`
  position: absolute;
  top: 100%;
  left: ${({ isOutOfViewport }) =>
    isOutOfViewport && isOutOfViewport?.right > 480
      ? 0
      : isOutOfViewport &&
        isOutOfViewport?.right < 480 &&
        isOutOfViewport?.left > 480
      ? "auto"
      : `-${(isOutOfViewport && isOutOfViewport?.left - 25) || 0}px`};

  right: ${({ isOutOfViewport }) =>
    isOutOfViewport && isOutOfViewport?.right > 480
      ? "auto"
      : isOutOfViewport &&
        isOutOfViewport?.right < 480 &&
        isOutOfViewport?.left > 480
      ? 0
      : "auto"};
  width: 500px;
  max-width: 500px;
  background: ${({ theme }) => theme.primaryBG};
  padding: ${({ theme }) => theme.resolve("spacing_2xl")};
  box-shadow: 0 4px 8px 0 ${({ theme }) => theme.shadowColor};
  border-radius: ${({ theme }) => theme.resolve("radius_xxs")};
  z-index: 900 !important;
  /* Focused programmatically (tabIndex -1) on a pointer open; not a tab stop. */
  &:focus {
    outline: none;
  }
`;
